import api from '@/lib/api';

const BASE = (pid) => `/participants/${pid}/documents`;

export async function listParticipantDocuments(participantId, params = {}) {
  const searchParams = new URLSearchParams();
  if (params.category) searchParams.append('category', params.category);
  if (params.status) searchParams.append('status', params.status);
  if (params.search) searchParams.append('search', params.search);
  if (params.page) searchParams.append('page', params.page);
  if (params.pageSize) searchParams.append('pageSize', params.pageSize);
  const qs = searchParams.toString();
  const r = await api.get(`${BASE(participantId)}${qs ? '?' + qs : ''}`);
  return r.data;
}

export async function getParticipantDocument(participantId, documentId) {
  const r = await api.get(`${BASE(participantId)}/${documentId}`);
  return r.data.data;
}

export async function uploadParticipantDocument(participantId, formData) {
  const r = await api.post(BASE(participantId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return r.data.data;
}

export async function archiveParticipantDocument(participantId, documentId) {
  const r = await api.delete(`${BASE(participantId)}/${documentId}`);
  return r.data.data;
}

export function getDownloadUrl(participantId, documentId) {
  return `${BASE(participantId)}/${documentId}/download`;
}
